import axiosInstance from './axiosConfig';

/**
 * 管理画面「UGC 出演者・場所」API クライアント（/admin/ugc-presets）。
 * 画像は upload で置いてキーを受け取り、作成・更新の image_key に入れる。
 */

export type UgcPresetKind = 'talent' | 'location';

export interface AdminUgcPreset {
  id: number;
  kind: UgcPresetKind;
  name: string;
  description: string | null;
  image_key: string | null;
  image_url: string | null;
  prompt_hint: string | null;
  voice: string | null;
  sort_order: number;
  is_active: boolean;
}

export type UgcPresetInput = Partial<Omit<AdminUgcPreset, 'id' | 'image_url'>> & { kind?: UgcPresetKind; name?: string };

/** Gemini TTS の声（backend VideoDocumentVoices と同じ並び） */
export const UGC_VOICES: { key: string; label: string }[] = [
  { key: 'Kore', label: '落ち着いた女性' },
  { key: 'Puck', label: '明るい男性' },
  { key: 'Charon', label: '信頼感のある男性' },
  { key: 'Aoede', label: '軽やかな女性' },
  { key: 'Fenrir', label: '力強い男性' },
  { key: 'Leda', label: '若々しい女性' },
  { key: 'Orus', label: '堅実な男性' },
  { key: 'Zephyr', label: '明るい女性' },
];

const adminUgcPresetService = {
  async list(kind?: UgcPresetKind): Promise<AdminUgcPreset[]> {
    const response = await axiosInstance.get('/admin/ugc-presets', { params: kind ? { kind } : {} });
    return response.data.data ?? [];
  },

  async create(input: UgcPresetInput): Promise<AdminUgcPreset> {
    const response = await axiosInstance.post('/admin/ugc-presets', input);
    return response.data.data;
  },

  async update(id: number, input: UgcPresetInput): Promise<AdminUgcPreset> {
    const response = await axiosInstance.put(`/admin/ugc-presets/${id}`, input);
    return response.data.data;
  },

  async toggle(id: number): Promise<AdminUgcPreset> {
    const response = await axiosInstance.put(`/admin/ugc-presets/${id}/toggle`);
    return response.data.data;
  },

  async remove(id: number): Promise<void> {
    await axiosInstance.delete(`/admin/ugc-presets/${id}`);
  },

  async upload(file: File): Promise<{ key: string; url: string | null }> {
    const form = new FormData();
    form.append('file', file);
    const response = await axiosInstance.post('/admin/ugc-presets/upload', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  },
};

export default adminUgcPresetService;
